<script>
import { mapState } from "vuex";
import { addMonths, subYears, format } from 'date-fns'

export default {
  props: {
    prepare: {
      type: Boolean,
      default: false,
    },
    customProps: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      loading: null,
      firstName: "",
      jornayaLeadidToken: "",
      trustedFormId: "",
      trustedFormUrl: "",
      tapStoneAds: document.getElementById('tap-stone-ads').innerHTML
    };
  },

  computed: {
    ...mapState([
      "fields",
      "highRisk"
      ]),
  },

  created() {
    let campaignId = 3499
    let supplierId = 5948
    let key = '7drtd35ce6x'

    const searchParams = new URLSearchParams(location.search)
    const lpCampaignIdFromUrl = searchParams.get('lp_campaign_id')
    const lpSupplierIdFromUrl = searchParams.get('lp_supplier_id')
    const keyFromUrl = searchParams.get('lp_key')

    if (lpCampaignIdFromUrl !== null && lpSupplierIdFromUrl !== null && keyFromUrl !== null) {
      campaignId = lpCampaignIdFromUrl
      supplierId = lpSupplierIdFromUrl
      key = keyFromUrl
    }

    this.$store.dispatch('setAnswers', [
      {
        field: "lp_campaign_id",
        value: campaignId,
      },
      {
        field: "lp_supplier_id",
        value: supplierId,
      },
      {
        field: "lp_key",
        value: key,
      },
    ])

    if (this.prepare) {
      this.$emit('show-this-step')
    }
  },

  mounted() {
    if (!this.prepare) {
      this.setTrustedFormAndJornaya();

      let data = {
        primary: {
          birth_date: this.fields["birthdate"],
            tobacco: this.fields["tobacco_0_1"],
            gender: this.fields["gender_m_f"]
        },
        county: this.fields["county"],
        phone: this.fields["phone_number"],
        state: this.fields["state"],
        zip: this.fields["zip_code"],
        household_income: this.fields["household_income"],
      }

      const acceptedCreditRatings = ['Excellent', 'Good', 'Average', 'Below Average', 'Poor']

      if (acceptedCreditRatings.includes(this.fields["credit_rating"])) {
        data['credit_rating'] = this.fields["credit_rating"]
      }

      this.postData();
    }
  },

  methods: {
    async postData() {
      const urlSearchParams = new URLSearchParams(location.search)

      // Default post url
      // let postUrl = "https://api.leadprosper.io/ingest"

      // if (urlSearchParams.has('send-to-control')) {
      //   postUrl = "https://control.org31415.dev/api/leads/ingest"
      // }

      const postUrl = 'https://control.org31415.dev/api/leads/ingest'

      let oid = 8

      if (urlSearchParams.has('oid')) {
        oid = Number(urlSearchParams.get('oid')) || 8
      }

      //set hardcoded values for expiration_date & insured_since
      const now = new Date()
      const oneMonthAfter = format(addMonths(now, 1), 'yyyy-MM-dd')
      const fiveYearsPrior = format(subYears(now, 5), 'yyyy-MM-dd')

      const params = {
        expiration_date: oneMonthAfter,
        insured_since: fiveYearsPrior,
        oid: oid,
        ...this.fields,
        affid: this.fields['affid'] || 1
      };

      window.localStorage.removeItem('fields')

      if (this.highRisk) return

      this.axios
        .post(postUrl, params)
        .then((response) => {
          console.log("Submit Success", response);
        })
        .catch((e) => {
          console.log("error ", e);
        });
    },

    setTrustedFormAndJornaya() {
      this.getJornayaLeadIdToken();
      this.getTrustedForm();
      this.$store.dispatch("setAnswers", [
        {
          field: "leadid_token",
          value: this.jornayaLeadidToken,
        },
        {
          field: "xxtrustedformcert",
          value: this.trustedFormId,
        },
        {
          field: "xxTrustedFormCertUrl",
          value: this.trustedFormUrl,
        },
      ]);
    },

    getJornayaLeadIdToken() {
      this.jornayaLeadidToken = document.getElementById("leadid_token").value;
    },

    getTrustedForm() {
      let tfCertUrl = document.getElementById("xxCertUrl_0").value;
      let tfParts = tfCertUrl.split("https://cert.trustedform.com/");
      this.trustedFormUrl = tfCertUrl;
      this.trustedFormId = tfParts[1];
    },
  },
};
</script>

<template>
  <div v-if="!prepare">
    <div class="container is-max-widescreen px-5">
      <div class="box has-text-centered item-box">
        <h2 class="question mb-3">
          Congrats, {{ fields.First_Name }} !
          <span class="is-block subtitle-question"
            >Click on an option to see your quote:</span
          >
        </h2>
        <div v-html="tapStoneAds"></div>
      </div>
    </div>
  </div>
</template>
